import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PendingTasksService {

  private tasks = new Map<number, string>()
  private nextTaskId: number = 1

  private _isBusy = new BehaviorSubject<boolean>(false)
  public isBusy = this._isBusy.asObservable()

  public addTask(description?: string): number {
    const taskId = this.nextTaskId++
    this.tasks.set(taskId, description || '')
    this._isBusy.next(true)
    return taskId
  }

  public removeTask(taskId: number): void {
    this.tasks.delete(taskId)
    if (this.tasks.size == 0) this._isBusy.next(false)
  }

}
